export const parseYear = (value?: string | null | Date): number | null => {
  if (!value) return null;
  const v = String(value).trim();

  const yearOnly = /^\d{4}$/;
  if (yearOnly.test(v)) return Number(v);

  const isoDate = /^(\d{4})-\d{2}-\d{2}/;
  const isoMatch = v.match(isoDate);
  if (isoMatch) return Number(isoMatch[1]);

  const parsed = new Date(v);
  if (!Number.isNaN(parsed.getTime())) return parsed.getFullYear();

  return null;
};

export const rangeInclusive = (start: number, end: number): number[] => {
  if (start > end) return [];
  const arr: number[] = [];
  for (let y = start; y <= end; y++) arr.push(y);
  return arr;
};

export const hasEmptyPrice = (price?: number | string | null) => {
  return price === undefined || price === null || price === '';
};
export const isValidNumber = (price?: number | string | null) => {
  return typeof price !== 'number' || isNaN(price) || price < 0;
};
export const isValidProjection = (projected: number | null, price?: number | string | null) => {
  return (
    projected !== null && typeof price === 'number' && Math.round(price * 100) / 100 < Math.round(projected * 100) / 100
  );
};
